// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Json_encode = require("@glennsl/bs-json/src/Json_encode.res.js");
var Utils$ReactHooksTemplate = require("../../common/utils.res.js");
var TextSelected$ReactHooksTemplate = require("./textSelected.res.js");

var categoryType = "text";

function setSelected(selected, param) {
  return {
          selected: selected
        };
}

function resetSelected(param) {
  return {
          selected: undefined
        };
}

function fromJson(json) {
  return {
          selected: Json_decode.withDefault(undefined, (function (param) {
                  return Json_decode.field("selected", (function (param) {
                                return Json_decode.optional(TextSelected$ReactHooksTemplate.decode, param);
                              }), param);
                }), json)
        };
}

function toString(t) {
  var selected = t.selected;
  if (selected !== undefined) {
    return TextSelected$ReactHooksTemplate.toString(Caml_option.valFromOption(selected));
  } else {
    return "";
  }
}

function isSelected(t) {
  return Belt_Option.isSome(t.selected);
}

function encodeParams(t) {
  return Utils$ReactHooksTemplate.encodeOptionalParamToList("selected", t.selected, TextSelected$ReactHooksTemplate.encode);
}

function encode(t) {
  return Json_encode.object_({
              hd: [
                "category_type",
                categoryType
              ],
              tl: {
                hd: [
                  "params",
                  Json_encode.object_(encodeParams(t))
                ],
                tl: /* [] */0
              }
            });
}

exports.categoryType = categoryType;
exports.setSelected = setSelected;
exports.resetSelected = resetSelected;
exports.fromJson = fromJson;
exports.toString = toString;
exports.isSelected = isSelected;
exports.encodeParams = encodeParams;
exports.encode = encode;
/* Utils-ReactHooksTemplate Not a pure module */
